<template>
  <div>
    <!--  api管理-->
    <baseBreadcrumb :page="$t('message.apiManagement')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">

      <!-- <a href="https://apimanage.rakumart.com/operation.apiStats#" target="_blank">
        <el-button type="primary">api开放接口</el-button>
      </a> -->
      <iframe src="https://apimanage.rakumart.com/operation.apiStats#" frameborder="0" style="width: 100%; "
        :style="{ height: tableautoheight + 'px' }"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 250 : 800,
    };
  },
  created() {

  },
  methods: {

  }
}
</script>
<style lang='scss' scoped></style>